import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getEngineUpdateNotificationSettings, saveEngineUpdateNotificationSettings } from '../service';
import { EngineUpdateNotificationSettings } from '../types';

export const engineUpdateNotificationsKeys = {
  root: ['ipa', 'setup', 'engine-update-notifications'] as const,
  settings: () => [...engineUpdateNotificationsKeys.root, 'settings'] as const,
};

export const useEngineUpdateNotificationSettingsQuery = () =>
  useQuery({
    queryKey: engineUpdateNotificationsKeys.settings(),
    queryFn: getEngineUpdateNotificationSettings,
  });

export const useSaveEngineUpdateNotificationSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: EngineUpdateNotificationSettings) => saveEngineUpdateNotificationSettings(settings),
    onSuccess: settings => queryClient.setQueryData(engineUpdateNotificationsKeys.settings(), settings),
  });
};
